import React from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { Tab as IdentityVerifyUploadTab } from '@/components/organisms/self-checkin/identity-verify/tab'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type IdentityVerifyUploadType = 'license' | 'passport'

type Props = {
  type: IdentityVerifyUploadType
  heading: string
  notice: React.ReactNode
}

export const IdentityVerifyUploadSection: React.FC<Props> = ({ type, heading, notice, children }) => (
  <div>
    <div css={tabContainerStyle}>
      <IdentityVerifyUploadTab currentTab={type} />
    </div>
    <div css={contentStyle}>
      <h2 css={headingStyle}>{heading}</h2>
      <p css={[noticeStyle, noticeLineBreakStyles[type]]}>{notice}</p>
      {children}
    </div>
  </div>
)

const tabContainerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const contentStyle = css(
  {
    borderRadius: '0 0 10px 10px',
    background: '#FFF',
    padding: 40,
  },
  createSelfCheckinResponsiveStyle({
    portrait: { borderRadius: 0 },
  }),
)

const headingStyle = css(
  {
    margin: 0,
    color: '#272727',
    fontSize: 22,
    fontWeight: 'bold',
    lineHeight: '30px',
    letterSpacing: '1.1px',
    textAlign: 'center',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 26, lineHeight: '35px', letterSpacing: '1.3px' },
  }),
)

const noticeStyle = css(
  {
    maxWidth: 982,
    margin: '8px auto 0',
    color: '#676767',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '22px',
    letterSpacing: '0.8px',
    textAlign: 'center',
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { fontSize: 20, lineHeight: '27px', letterSpacing: '1px' },
  }),
)

// ja の注意文だけ文の区切りに <br /> がある。Figma が文の区切りで改行している幅（免許証は横向き11インチ、パスポートは横向き11インチと縦向き）だけ改行を残し、ほかの幅は Figma と同じく幅いっぱいで折り返す
const noticeLineBreakStyles: Record<IdentityVerifyUploadType, SerializedStyles> = {
  license: css(
    createSelfCheckinResponsiveStyle({
      portrait: { br: { display: 'none' } },
      landscape13: { br: { display: 'none' } },
    }),
  ),
  passport: css(
    createSelfCheckinResponsiveStyle({
      landscape13: { br: { display: 'none' } },
    }),
  ),
}
